import { jsx } from "react/jsx-runtime";
import { memo, forwardRef } from "react";
import { IconBase } from "src/components/ui/IconBase";
export default memo(forwardRef(function IconSvgClose({
  className,
  "data-test-id": dataTest = "IconClose",
  ...props
}, ref) {
  return /* @__PURE__ */ jsx(IconBase, { ...props, "data-test-id": dataTest, className, innerRef: ref, children: /* @__PURE__ */ jsx("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", style: {
    width: 24,
    height: 24
  }, children: /* @__PURE__ */ jsx("path", { fill: "currentColor", d: "M12 14 6 8 4.5 9.5 12 17l7.5-7.5L18 8z" }) }) });
}));
